import React from 'react';
import { motion } from 'framer-motion';
import AdsClickOutlinedIcon from '@mui/icons-material/AdsClickOutlined';
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';
import PhotoSizeSelectLargeOutlinedIcon from '@mui/icons-material/PhotoSizeSelectLargeOutlined';
import SaveAltOutlinedIcon from '@mui/icons-material/SaveAltOutlined';
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';
import PaletteOutlinedIcon from '@mui/icons-material/PaletteOutlined';
const FRAME_STYLES = [{
  name: 'Raw',
  color: '#ffffff'
}, {
  name: 'Soft',
  color: '#eef2f7'
}, {
  name: 'Sunset',
  color: '#f8cfc2'
}, {
  name: 'Berry',
  color: '#e7d4f8'
}, {
  name: 'Mint',
  color: '#cfeedd'
}, {
  name: 'Midnight',
  color: '#1e2b3c'
}];
const FEATURES = [{
  icon: AdsClickOutlinedIcon,
  title: 'Pick mode',
  body: 'Click the toolbar icon, then click the posts you want. A crosshair cursor and highlight outline make it obvious what will be captured.'
}, {
  icon: ForumOutlinedIcon,
  title: 'Selected Posts and Replies',
  body: 'Include the main post plus any specific replies you choose, then export them together as one stitched PNG.'
}, {
  icon: PhotoSizeSelectLargeOutlinedIcon,
  title: 'Full-post capture',
  body: 'Long posts are automatically scrolled and stitched into one image — even when they’re far taller than your browser window.'
}, {
  icon: SaveAltOutlinedIcon,
  title: 'Download and Share',
  body: 'You can not only save the screenshots, but the text info and photos of the X posts as well.'
}, {
  icon: ShieldOutlinedIcon,
  title: '100% local',
  body: 'No server, no account, no analytics, no telemetry. Everything happens on your own device.'
}, {
  icon: PaletteOutlinedIcon,
  title: 'Choose the frame color you like',
  body: 'Wrap your capture in the backdrop that fits the moment — Raw, Soft, Sunset, Berry, Mint or Midnight. Switch styles and the preview updates instantly, so what you download or copy is exactly what you see.',
  swatches: true
}];
export function Features() {
  return <section id="features" className="w-full scroll-mt-16 bg-white py-20 sm:py-24" data-id="element-27" data-mp="2x3i6p1c1s7y5">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-28" data-mp="35y66wd2rmzg3">
        <div className="mx-auto max-w-2xl text-center" data-id="element-29" data-mp="35yzfljlabz0v">
          <h2 className="text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl" data-id="element-30" data-mp="3axj33ofj1ivc">
            Everything you need to screenshot X posts
          </h2>
          <p className="mt-4 text-lg text-slate-600" data-id="element-31" data-mp="3fygmg4c9wiyf">
            Built for clean, complete captures — without copy-paste, stitching,
            or third-party tools.
          </p>
        </div>

        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-32" data-mp="3ow90z6a67mkr">
          {FEATURES.map((f, i) => <motion.div key={f.title} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          delay: i % 3 * 0.08
        }} className="group rounded-2xl border border-slate-200 bg-white p-6 transition-all hover:border-[#1d9bf0]/40 hover:shadow-md" data-id="element-33" data-mp="1qjsag47lh30x" data-mpi={i}>
              <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-[#1d9bf0]/10 text-[#1d9bf0]" data-id="element-34" data-mp="20z9ly1uwcrjy">
                <f.icon data-id="element-35" data-mp="1wwwixl7jb7qv" />
              </span>
              <h3 className="mt-4 text-lg font-semibold text-slate-900" data-id="element-36" data-mp="1wvuxcmsw72uw">
                {f.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-600" data-id="element-37" data-mp="1s0xl770bgdds">
                {f.body}
              </p>
              {f.swatches && <ul className="mt-4 flex flex-wrap gap-2" data-id="element-38" data-mp="giej93mtilqy">
                  {FRAME_STYLES.map(s => <li key={s.name} className="flex items-center gap-1.5 rounded-full border border-slate-200 py-1 pl-1 pr-2.5 text-xs font-medium text-slate-600" data-id="element-39" data-mp="24fcac9ex3ec5">
                      <span className="h-4 w-4 rounded-full border border-slate-300" style={{
                backgroundColor: s.color
              }} data-id="element-40" data-mp="1vdcsxfzzq88o" />
                      {s.name}
                    </li>)}
                </ul>}
            </motion.div>)}
        </div>
      </div>
    </section>;
}